import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getDeltakerInfoDemaskert,
  postDemaskertDeltaker,
} from 'services/deltaker/deltakerService';
import { DeltakerInfoDemaskertDto } from 'services/deltaker/dto';
import { TraceableError } from 'utils/errors/customError';
import { setDemaskerDialogOpen } from './slice';
import { setShouldRefetchLogg } from '../logg/slice';

const typeName = 'deltaker/infoDemaskert';

export const demaskDeltaker = createAsyncThunk<
  DeltakerInfoDemaskertDto | undefined,
  {
    deltakerId: number;
    årsakId?: number;
    refetchLogg?: boolean;
  },
  { rejectValue: string }
>(
  `${typeName}`,
  async (
    { deltakerId, årsakId, refetchLogg },
    { rejectWithValue, dispatch }
  ) => {
    try {
      const result = await getDeltakerInfoDemaskert(deltakerId);
      if (refetchLogg) {
        dispatch(setShouldRefetchLogg(true));
      }
      return result;
    } catch (err) {
      if (årsakId) {
        try {
          await postDemaskertDeltaker(deltakerId, årsakId);
          const demaskertInfo = await getDeltakerInfoDemaskert(deltakerId);
          if (refetchLogg) {
            dispatch(setShouldRefetchLogg(true));
          }
          return demaskertInfo;
        } catch (error) {
          const err = error as TraceableError;
          return rejectWithValue(err.message);
        }
      } else {
        dispatch(
          setDemaskerDialogOpen({
            open: true,
            deltakerId,
            refetchLogg,
          })
        );
        return;
      }
    }
  }
);
